import type { MouseEvent } from 'react';

/** What inside a row is pressed for its own sake, not to open the row. */
const INTERACTIVE = 'a, button, input, select, textarea, label, summary, [role="button"], [role="menuitem"], [role="switch"], [role="checkbox"], [data-row-ignore]';

/**
 * Whether a press on a row is a plain press meant to open it (CO-185): the
 * main button, no modifier, not on a control inside the row, and not while
 * text is being selected.
 */
export function isRowPress(event: MouseEvent<HTMLElement>): boolean {
  if (event.defaultPrevented || event.button !== 0) return false;
  if (event.metaKey || event.ctrlKey || event.shiftKey) return false;
  if ((event.target as HTMLElement).closest(INTERACTIVE)) return false;
  return !window.getSelection()?.toString();
}

/**
 * Props for a `<tr>` that opens its item when pressed anywhere. The row's
 * first cell must still hold a real link or button naming the item, which
 * is what keyboards and screen readers use.
 */
export function clickableRow(open: () => void): { className: string; onClick: (event: MouseEvent<HTMLElement>) => void } {
  return {
    className: 'table__row--link',
    onClick: (event) => {
      if (isRowPress(event)) open();
    },
  };
}
